export enum CombinedLongeingStatusEnum {
  SUBMITTED = 'submitted',
  COMPLETE = 'complete',
}
